import { MessageService } from 'primeng/api';

import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly messageService = inject(MessageService);

  showToast(severity: string, detail: string, httpCode?: number, key?: string): void {
    if (severity === 'error') {
      const summary = httpCode ? `HTTP ${httpCode}` : 'Error';

      this.messageService.add({
        summary,
        severity,
        detail,
        sticky: true,
        closable: true,
      });
    } else {
      this.messageService.add({
        severity,
        detail,
        key,
      });
    }
  }
}
